<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs6 md6>
        <v-text-field
          class="purple-input"
          label="Título da Obra"
          messages="Título da Obra que será utilizado para vincular os fonogramas e aumentar a rentabilidade dos compositores."
          v-model="work.name"
        />
      </v-flex>     

      <v-flex xs6 md6>
        <v-text-field
          class="purple-input"
          label="ISWC"
          messages="Código de registro mundial da obra gerado pela sociedade a qual você é vinculado."
          v-model="work.iswc"
        />
      </v-flex>
      
<v-flex xs12>
  <v-switch v-model="work.version" label="Essa obra é uma versão?"></v-switch>
</v-flex>
      <v-flex xs12 md12 v-if="work.version">
        <v-text-field
          class="purple-input"
          label="Título da Obra Original"
          messages="Título da Obra que será utilizado para vincular os fonogramas e aumentar a rentabilidade dos compositores."
          v-model="work.br_name_original"
        />
      </v-flex>     

      <!--v-flex xs6 md6 v-if="work.version">
        <v-text-field
          class="purple-input"
          label="Versionista"
          messages="Nome do Versionista"
          v-model="work.br_versionista"
        />
      </v-flex-->


      <v-flex xs12 md12 v-if="work.custom_name">
        <v-text-field
          class="purple-input"
          label="Nome"
          messages="Nome customizado. Enviado através da API."
          v-model="work.custom_name"
          disabled
        />
      </v-flex>

      <v-flex xs6 >
        <v-textarea
          auto-grow
          
          label="Letra"
          v-model="work.lyric"
        ></v-textarea>
      </v-flex>
       <v-flex xs6 >
       
      </v-flex>


    </v-layout>
  </v-container>
</template>

<script>


export default {
  data: () => ({
    work: {}   
  }),
  props:{
    workdata: Object
  },  
  watch:{
    work:{
      handler:function(){
        this.$emit('work_data', this.work)
      },
      deep:true      
    },
    workdata:function(){
      this.work = this.workdata;
    }
  }
};
</script>


